import Menu from '@/assets/icons/menu.svg'
import { useRouter } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { useWindowSize } from 'react-use'
import { Drawer } from 'rsuite'
import DrawerContent from '../drawer-content'
import styles from './styles.module.scss'

type Props = {
  text: string
  subText: string
  buttonText?: string
  buttonDisable?: boolean
}
export default function EmptyData({
  text,
  subText,
  buttonText,
  buttonDisable = false,
}: Props) {
  const [open, setOpen] = useState(false)
  const { width } = useWindowSize()
  const router = useRouter()
  const t = useTranslations('General')

  return (
    <>
      <div className={styles.root}>
        <p className={styles.title}>{text ? text : ''}</p>
        <p className={styles.subTitle}>{subText ? subText : ''}</p>
        {buttonDisable ? (
          ''
        ) : (
          <div className={styles.buttonBox}>
            {buttonText ? (
              <button
                type="button"
                onClick={() => router.push('/')}
                className={styles.button}
              >
                <Menu />
                {buttonText}
              </button>
            ) : (
              <button
                type="button"
                className={styles.button}
                onClick={() => setOpen(true)}
              >
                <Menu />
                {t('catalog-products')}
              </button>
            )}
          </div>
        )}
      </div>
      <Drawer
        size={`${
          width <= 767
            ? 'calc(100% - 0px'
            : width <= 1241
            ? 'calc(100% - 50px'
            : width <= 1510
            ? 'calc(100% - 100px'
            : width <= 1750
            ? 'calc(100% - 258px'
            : 'calc(100% - 490px'
        })`}
        placement="left"
        // backdrop="static"
        onClose={() => setOpen(false)}
        open={open}
        closeButton={false}
      >
        <Drawer.Body style={{ padding: '0' }}>
          <div style={{ height: '100%' }}>
            <DrawerContent closeButton={() => setOpen(false)} />
          </div>
        </Drawer.Body>
      </Drawer>
    </>
  )
}
